import React from 'react';
import { Collapse, DropdownItem } from 'shards-react';

const list = [
    {
        title: 'Low',
        label: '1 Day',
        key: 'priority',
        value: 'low'
    },
    {
        title: 'Medium',
        label: '2 Days',
        key: 'priority',
        value: 'medium'
    },
    {
        title: 'High',
        label: '3 to 4 Days',
        key: 'priority',
        value: 'high'
    },
    {
        title: 'Urgent',
        label: 'Over 4 Days',
        key: 'priority',
        value: 'urgent'
    },
    {
        title: '',
        label: 'Remove Filter',
        key: 'remove',
        value: null
    }
]

class PriorityFilter extends React.Component {
    state = {
        visible: false
    }

    componentDidUpdate(props) {
        if (this.props.visible !== props.visible) {
            this.setState({ visible: this.props.visible })
        }
    }

    render() {
        return (
            <Collapse
                open={this.state.visible}
                className='dropdown-menu dropdown-menu-small'
            >
                {list.map((item, idx) => {
                    if (item.value) {
                        return (
                            <div key={idx}>
                                <DropdownItem>
                                    <div className='notification__content' onClick={() => this.props.onSelect({
                                        key: item.key,
                                        value: item.value,
                                        title: item.title
                                    })}>
                                        <span className='notification__category stats-small__label text-uppercase'>{item.title}</span>
                                        <p className='mb-0 text-capitalize'>
                                            {item.label.replace(/_/g, ' ')}
                                        </p>
                                    </div>
                                </DropdownItem>
                            </div>
                        )
                    }

                    return (
                        <div key={idx}>
                            <div style={{ height: '8px' }}><hr /></div>
                            <DropdownItem>
                                <div className='notification__content' onClick={() => this.props.onSelect({
                                    key: item.key,
                                    value: item.value,
                                    title: item.title
                                })}>
                                    <span className='notification__category stats-small__label text-uppercase'>{item.title}</span>
                                    <p className='mb-0 text-capitalize'>
                                        {item.label.replace(/_/g, ' ')}
                                    </p>
                                </div>
                            </DropdownItem>
                        </div>
                    )
                })}
            </Collapse>
        )
    }

}

export default PriorityFilter;